import React, { useEffect, useState } from 'react';

const NewsComponent = () => {
    const [data, setData] = useState([]);

    useEffect(() => {
        let companyNames = []
        const fetchNews = async () => {
            try {

                let url = process.env.NODE_ENV === 'development'
                ? process.env.REACT_APP_POSITION_SERVICE_DEV : "";

                const positionsRes = await fetch(url + '/positions');
                const positionResult = await positionsRes.json();
                const companyNames = []

                Object.entries(positionResult).forEach(([ticker, value]) => {
                    companyNames.push(encodeURIComponent(value['name']));
                });

                
                console.log(companyNames);
                url = process.env.NODE_ENV === 'development'
                ? process.env.REACT_APP_NEWS_SERVICE_DEV : "";

                let newsUrl = url + "/news?companies=" + companyNames.join(",");
                console.log(newsUrl);
                const newsRes = await fetch(newsUrl);

                const news = await newsRes.json();
                console.log(news);
                setData(news);

//                 const jsonString = JSON.stringify(news, null, 2);
//                 const blob = new Blob([jsonString], {type: 'application/json'});
//                 const url = URL.createObjectURL(blob);
//                 const anchor = document.createElement('a');
//                 anchor.href= url;
//                 anchor.download = 'news_data.json';
//                 anchor.click();

//                 let testNews = [
//                     {company: 'Chicago Atlantic Real Estate Finance',
//                      title: 'Creative Planning Buys 17,422 Shares of Walgreens Boots Alliance, Inc. (NASDAQ:WBA)',
//                      url: 'https://www.etfdailynews.com/2024/03/14/creative-planning-buys-17422-shares-of-walgreens-boots-alliance-inc-nasdaqwba/'},
//                     {company: 'AT&T',
//                      title: 'Pit Babe\u2019s Asia Tour First Fan Meeting in Hong Kong: Date, Time, Venue & More',
//                      url: 'https://www.comingsoon.net/thai-drama/news/1604622-pit-babes-asia-tour-first-fan-meeting-in-hong-kong-date-time-venue-more'}
//                 ];
//                 setData(testNews);
            } catch (error) {
                console.error("error in fetching news.", error);
            }
        };

        fetchNews();
    }, []);

    return (
        <React.Fragment>
            <div>
                <h1>Position News</h1>
                <table style={{borderSpacing: '0', width: '80%' }}>
                    <tbody>
                        {data.map(item => (
                            <tr>
                                <td style={{textAlign: 'left', display: 'block', "margin-left": '200px',
                                                                             "margin-bottom": "15px",
                                                                             "fontSize": '20px',
                                                                             color: 'blue', width: '300px' }}>
                                     [{item.company}]
                                </td>
                                <td style={{"margin-left": '10px',
                                             "fontSize": '20px',
                                             "vertical-align": "top",
                                             color: 'blue', width: '200px' }}> {item.source} </td>
                                <td>
                                    <a href={item.url} target="_blank" rel="noopener noreferrer"
                                       style={{ textAlign: 'left', display: 'block', "margin-left": '0px',
                                         "margin-bottom": "15px",
                                         "fontSize": '20px',
                                         color: 'blue', width: '1400px' }}>
                                       {item.title}
                                    </a>
                                </td>
                            </tr>
                        ))
                        }
                    </tbody>
                </table>
            </div>

        </React.Fragment>
    );
};

export default NewsComponent;
